// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"962":"home","966":"login"}[chunkId] + "." + {"962":"e20abac2077cac4c","966":"745721f7796b69b1"}[chunkId] + ".js";
};